module.exports = __webpack_public_path__ + "montserrat.svg?fd06d68d10dfe9a9886abc212664c75d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/montserrat.svg
// module id = 237
// module chunks = 10